import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	AP_MAC_ACL_FILTER_EVENT,
	AP_MAC_ACL_FOCUS_EVENT,
	AP_MAC_ACL_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['profile.ap_mac_acls']);

/**
 * Open Access Controls and bring Access Point MAC ACL into view.
 *
 * Five collections share this one accordion, and two of them are behind an
 * inner tab pair, so the section is named per collection rather than per
 * accordion - the page selects the tab when it needs to.
 *
 * @return {Promise<void>} completion acknowledgement
 */
export function openApMacAclSection() {
	return openResourceSection(
		AP_MAC_ACL_SECTION_EVENT,
		'profile.ap_mac_acls',
		SECTIONS,
	);
}

/**
 * Filter the Access Point MAC ACL table to a search term.
 * @param {string} query search text
 * @return {Promise<void>} acknowledgement
 */
export function applyApMacAclFilter(query) {
	return dispatchAcknowledgedEvent(AP_MAC_ACL_FILTER_EVENT, {
		query: String(query || '').trim(),
		resource: 'ap_mac_acl',
	});
}

/**
 * Point at one Access Point MAC ACL row in the table.
 * @param {string} entityId identifier
 * @return {Promise<void>} acknowledgement
 */
export function focusApMacAcl(entityId) {
	if (!entityId) return Promise.reject(new Error('invalid_ap_mac_acl_focus'));
	return dispatchAcknowledgedEvent(AP_MAC_ACL_FOCUS_EVENT, {
		entityId: String(entityId),
		resource: 'ap_mac_acl',
	});
}
